import md5 from 'js-md5'
function getSign (map, accessSecret) {
  const array = []
  for (const key in map) {
    array.push(key)
  }
  array.sort()
  const keys = Array.from(array)
  let resultStr = ''
  let first = true
  for (let i = 0; i < keys.length; i++) {
    if (first) {
      first = false
    } else {
      resultStr += '&'
    }
    const value = map[keys[i]]
    resultStr += keys[i]
    resultStr += '='
    let valueString = ''
    if (value != '' && value != null) {
      valueString = value
    }
    resultStr += valueString
  }
  resultStr += '&accessSecret=' + accessSecret
  return md5(resultStr).toUpperCase()
}

export default getSign
